import React from 'react';
import { Section } from './Section';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const points = ['Alerts are integrated via CloudSurgard — compatible with every alarm monitoring center, no changes required on their end.', 'Receive signals in SIA format, with full access to the triggering audio and complete signal trace.', 'If you already use CloudSurgard, you can deploy and manage Peoplecall Pod in seconds.'];
export function CloudSurgard() {
  return <Section id="cloudsurgard" className="bg-white" data-id="element-15">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-16">
        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative order-2 lg:order-1" data-id="element-17">
          <div className="absolute inset-0 bg-peoplecall/5 blur-3xl rounded-full" data-id="element-18" />
          <img src="https://cdn.magicpatterns.com/uploads/h9p1WUWTrgT1jfVQ28gqFh/laptop-clouds-2.png" alt="CloudSurgard interface showing acoustic signal analysis for Peoplecall Pod" className="relative w-full h-auto" data-id="element-19" />
        </motion.div>

        {/* Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="order-1 lg:order-2" data-id="element-20">
          <span className="text-peoplecall tracking-wider text-sm font-semibold mb-4 block" data-id="element-21">
            Integration
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight text-zinc-900" data-id="element-22">
            Compatible with CloudSurgard.
          </h2>
          <p className="text-lg text-zinc-600 mb-10 leading-relaxed" data-id="element-23">
            No integration projects. No custom development. Peoplecall Pod plugs
            into your existing alarm infrastructure on day one.
          </p>

          <ul className="space-y-5" data-id="element-24">
            {points.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2 + index * 0.1
          }} className="flex gap-4 items-start" data-id="element-25">
                <div className="mt-1 w-6 h-6 rounded-full bg-peoplecall/10 flex items-center justify-center flex-shrink-0" data-id="element-26">
                  <Check className="w-4 h-4 text-peoplecall" strokeWidth={3} data-id="element-27" />
                </div>
                <span className="text-zinc-700 text-base leading-relaxed" data-id="element-28">
                  {point}
                </span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </Section>;
}